import { combineReducers } from 'redux';

import {
  setOpenVideoInstructionModal,
  setInlineVideoInstruction,
  setVideoInstructionId,
} from '../../actions';
import { ScriptEditorAction, VideoInstructionState } from '../../types';
import { Reducer } from '../../../../types';
import videos from './videos';

type ReducerOf<T extends keyof VideoInstructionState> = Reducer<VideoInstructionState, ScriptEditorAction, T>;

const isOpenModal: ReducerOf<'isOpenModal'> = (state = false, action) => {
  switch (action.type) {
    case setOpenVideoInstructionModal.type:
      return action.payload;

    default:
      return state;
  }
};

const instructionId: ReducerOf<'instructionId'> = (state = '', action) => {
  switch (action.type) {
    case setVideoInstructionId.type:
      return action.payload;

    default:
      return state;
  }
};
const isInline: ReducerOf<'isInline'> = (state = true, action) => {
  switch (action.type) {
    case setInlineVideoInstruction.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers({
  isOpenModal,
  isInline,
  instructionId,
  videos,
});
